"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessage = getErrorMessage;
function hasMessage(error) {
    return typeof error === 'object' && error !== null && 'message' in error;
}
function getErrorMessage(error, fallbackMessage) {
    if (hasMessage(error))
        return String(error.message);
    return fallbackMessage;
}
